import { all, call, put, takeLatest } from "redux-saga/effects";

import { ApiManager } from "services/api";
import { TagSerializer } from "services/api/tag";
import { CRUDAction, RequestAction } from "store/entities/actions";
import { INTEGRATION } from "store/entities/integrations";
import { ALL_TEAMS_ID } from "store/entities/teams";
import { IActionWithPayload } from "store/helper";

import { TAG, TagActions } from "./actions";
import { ICreateTagPayload, IDeleteTagPayload, IFetchSinglePayload, IUpdateTagPayload } from "./interfaces";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function* fetchSingle(action: IActionWithPayload<string, IFetchSinglePayload>) {
  const { id } = action.payload;
  // @ts-expect-error TS(7057): 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
  const response = yield call(ApiManager.tagApi.fetch, id);
  if (response.result) {
    yield put(TagActions.fetchSuccess({ id, value: TagSerializer.deserialize(response.result) }));
  } else {
    yield put(TagActions.fetchFailure({ id, error: response.error.message }));
  }
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function* fetchCollection() {
  const { tagApi } = ApiManager;
  // @ts-expect-error TS(7057): 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
  const response = yield call(tagApi.fetchAll);

  if (response.result) {
    yield put(TagActions.fetchCollectionSuccess({ values: TagSerializer.deserializeList(response.result) }));
  } else {
    yield put(TagActions.fetchCollectionFailure({ error: response.error.message }));
  }
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* create(action: IActionWithPayload<string, ICreateTagPayload>) {
  const { name } = action.payload.value;
  let { teamId } = action.payload.value;
  if (teamId === ALL_TEAMS_ID) {
    teamId = null;
  }
  // @ts-expect-error TS(7057): 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
  const response = yield call(ApiManager.tagApi.create, { teamId, name });

  if (response.result) {
    const tag = TagSerializer.deserialize(response.result);
    yield put(TagActions.createSuccess({ id: tag.id, value: tag }));
  } else {
    yield put(TagActions.createFailure({ error: response.error.error }));
  }
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* update(action: IActionWithPayload<string, IUpdateTagPayload>) {
  const { id, name } = action.payload.value;
  // @ts-expect-error TS(7057): 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
  const response = yield call(ApiManager.tagApi.update, { id, name });

  if (response.result) {
    const tag = TagSerializer.deserialize(response.result, false);
    yield put(TagActions.updateSuccess({ id: tag.id, value: tag }));
  } else {
    // @ts-expect-error TS(2322): Type 'string | undefined' is not assignable to typ... Remove this comment to see the full error message
    yield put(TagActions.updateFailure({ id, error: response.error.message }));
  }
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* deleteTag(action: IActionWithPayload<string, IDeleteTagPayload>) {
  const { id } = action.payload;
  // @ts-expect-error TS(7057): 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
  const response = yield call(ApiManager.tagApi.deleteTag, id);

  if (response.result) {
    yield put(TagActions.deleteSuccess({ id }));
  } else {
    yield put(TagActions.deleteFailure({ id }));
  }
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function* tagsSagas() {
  yield all([
    takeLatest(TAG[CRUDAction.FETCH_SINGLE][RequestAction.REQUEST], fetchSingle),
    takeLatest(
      [
        TAG[CRUDAction.FETCH_COLLECTION][RequestAction.REQUEST],
        INTEGRATION.LIVECHAT_IMPORT_FINISHED,
        INTEGRATION.LIVECHAT_SELECTIVE_IMPORT_FINISHED,
      ],
      fetchCollection
    ),
    takeLatest(TAG[CRUDAction.CREATE][RequestAction.REQUEST], create),
    takeLatest(TAG[CRUDAction.UPDATE][RequestAction.REQUEST], update),
    takeLatest(TAG[CRUDAction.DELETE][RequestAction.REQUEST], deleteTag),
  ]);
}
